import PropTypes from 'prop-types';
import React, { Component } from 'react';

import defined from '~app/core/defined';

import ImageBlob from './ImageBlob';

class BiomeBanner extends Component {

  render() {
    return (
      <div className="BiomeBanner">
        <ImageBlob blob={this.props.imageBlob}>
          <div className="BiomeBanner__content">
            <div className="BiomeBanner__textContainer">
              {
                defined(this.props.biomeName) &&
                <p className="BiomeBanner__biome">
                  {this.props.biomeName}
                </p>
              }
              {
                defined(this.props.geocodedName) &&
                <p className="BiomeBanner__location">
                  {this.props.geocodedName}
                </p>
              }
              <p className="BiomeBanner__coordinates">
                {this.props.coordinates}
              </p>
            </div>
            {
              defined(this.props.onChange) &&
              <button className="BiomeBanner__changeButton"
                onClick={this.props.onChange}
              >
                <span className="BiomeBanner__changeButtonContents">
                  <p className="BiomeBanner__changeButtonTitle">
                    Change
                  </p>
                </span>
              </button>
            }
          </div>
        </ImageBlob>
      </div>
    );
  }

}

BiomeBanner.propTypes = {
  geocodedName: PropTypes.string,
  coordinates: PropTypes.string.isRequired,
  biomeName: PropTypes.string,
  imageBlob: PropTypes.object,
  onChange: PropTypes.func,
  isBusy: PropTypes.bool.isRequired,
};

export default BiomeBanner;



// WEBPACK FOOTER //
// ./src/components/BiomeBanner.js